// extracted by mini-css-extract-plugin
export default {"user_home":"userhome_user_home__5UJfq"};